import i18n from "config/i18next";

i18n.addResources("es", "emailRestore", {
  sendMail: "Enviar correo",
  email: "Email",
  restoreTitle: "Enviamos un correo a tu email",
  restoreMessage: "Ingresá al mismo para restaurar tu contraseña",
});
